import ApiService from '@/services/core/api.service'

const BudgetService = {
  async get (query = '') {
    return ApiService.get(`auditor/budgets?${query}`)
  }
}

export default BudgetService
